import validate from "/vercel/path0/rna-psych/node_modules/.pnpm/nuxt@3.19.0_@parcel+watcher@2.5.1_@vue+compiler-sfc@3.5.21_db0@0.3.2_eslint@8.57.1_iore_fbd252417a58e3ddbd6f624394ef1c0f/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/rna-psych/node_modules/.pnpm/nuxt@3.19.0_@parcel+watcher@2.5.1_@vue+compiler-sfc@3.5.21_db0@0.3.2_eslint@8.57.1_iore_fbd252417a58e3ddbd6f624394ef1c0f/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}